import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { identity } from 'ramda';

const getDeviceIdFromFingerprint = async () => {
  const fp = await FingerprintJS.load();
  const fpResult = await fp.get();

  return fpResult.visitorId;
};

export const getDeviceIdHeaderSetter = async () => {
  if (!window.fingerprintjsEnabled) {
    return identity;
  }

  const deviceId = await getDeviceIdFromFingerprint();

  return (headers = {}) => {
    const HEADER_NAME = 'x-device-id';

    if (headers instanceof Headers) {
      headers.set(HEADER_NAME, deviceId);
    } else {
      // eslint-disable-next-line no-param-reassign
      (headers as Record<string, unknown>)[HEADER_NAME] = deviceId;
    }

    return headers;
  };
};
